import React from 'react';
import { useFetchAbsoluteFrecuency } from '../../hooks/useFetchAbsoluteFrecuency';
import { format } from 'date-fns';
import { api_auth } from '../../../../common/globals/constants';
import { useDynamicViewState } from '../../context/dynamic-view-context';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { Alert } from '@mui/material';
import { Box } from '@material-ui/core';
import { AbsoluteFrecuency } from '../../../../components/IndividualCharts/ResponseTimeFrecuency/AbsoluteFrecuency';

const URL_PARAMS = ({ objetivoId, periodo }) => {
  let fechaInicio = '';
  let fechaTermino = '';
  if (periodo.period === 'c') {
    fechaInicio = format(new Date(periodo.statePeriod.startDate), 'yyyy-MM-dd');
    fechaTermino = format(new Date(periodo.statePeriod.endDate), 'yyyy-MM-dd');
  }

  const token = sessionStorage.getItem('key');
  const user = sessionStorage.getItem('user');
  const URL = new URLSearchParams();
  URL.append('user', user);
  URL.append('key', api_auth);
  URL.append('token', token);
  URL.append('horarioId', '0'); 
  URL.append('objetivoId', objetivoId);
  URL.append('t', periodo.period);
  URL.append('fechaInicio', fechaInicio);
  URL.append('fechaTermino', fechaTermino);
  return URL;
};

export const AbsoluteFrecuencyChart = React.memo(({ objetivoId }) => {
  const { filterPeriod, refreshTime } = useDynamicViewState();
  const {
    data: dataAbsoluteFrecuency,
    isLoading,
    error,
    isFetching,
  } = useFetchAbsoluteFrecuency({
    urlParams: URL_PARAMS({
      objetivoId,
      periodo: filterPeriod,
    }),
    fetchApi:
      filterPeriod.period === 'c'
        ? 'getFrecuenciaRendimientoGlobalObjetivoCustom'
        : 'getFrecuenciaRendimientoGlobalObjetivo',
    refreshTime,
  });

  if (isLoading || isFetching) return <AtCircularProgress />;
  if (error) return <Alert severity="error">Error al cargar los datos.</Alert>;

  return (
    <Box>
      <AbsoluteFrecuency externalData={dataAbsoluteFrecuency} schedule={0} />
    </Box>
  );
});
